import { useFlag } from '@acre/utils'

const usePreviewMode = () => {
  return {
    allowed: useFlag('feature.preview_mode', true),
    active: window.location.hostname.includes('crm-next'),
  }
}

export default usePreviewMode
